import Call from '__core/shared/model/call/Call';

export default angular
  .module('st.Call', ['st.Core', 'angular-cache'])
  .factory('Call', () => Call)
  .service('callService', ($q, $http, $window, $rootScope, dataService, Call, CALL) => {
    let currentCallId = '';

    const getCurrent = () => currentCallId;

    return {
      createCall: (doc) => dataService.createDocument(Call, doc),
      readCall: (doc) => dataService.readDocument(Call, doc),
      updateCall: (doc) => dataService.updateDocument(Call, doc),
      deleteCall: (doc) => dataService.deleteDocument(Call, doc),
      addToTicketAsNote: (params) =>
        dataService
          .apiRequest(
            null,
            null,
            true,
            null,
            $http.post,
            CALL.API.ADD_TO_TICKET_AS_NOTE,
            { params },
            ['idCall', 'idWorkflow', 'idTicket'],
            true
          )
          .then((result) => {
            return { status: result.status === true };
          }),
      answer: () =>
        dataService
          .apiRequest(
            null,
            null,
            true,
            null,
            $http.post,
            CALL.API.ANSWER,
            { params: { idCall: currentCallId } },
            ['idCall'],
            true
          )
          .then((result) => {
            if (result.status === true) {
              $window.plivoWebSdk.client.answer(currentCallId);
            }
          }),
      canRecord: () => _.isUuid(currentCallId),
      dtmf: (digit) => $window.plivoWebSdk.client.sendDtmf(digit),
      getCurrent,
      hangup: () => $window.plivoWebSdk.client.hangup(),
      login: () =>
        $window.plivoWebSdk.client.login(
          $rootScope.CurrentAccount.authentication.comms.username,
          $rootScope.CurrentAccount.authentication.comms.password
        ),
      logout: () => {
        try {
          $window.plivoWebSdk.client.logout();
        } catch (ignore) {}
      },
      mute: () => $window.plivoWebSdk.client.mute(),
      pickup: () => $window.plivoWebSdk.client.answer(),
      receive: (params) =>
        dataService
          .apiRequest(
            null,
            null,
            true,
            null,
            $http.post,
            CALL.API.RECEIVE,
            { params },
            ['source'],
            true
          )
          .then((result) => {
            if (result?.status) {
              currentCallId = result.id;
            }
            return { status: result.status === true };
          }),
      record: () =>
        dataService
          .apiRequest(
            null,
            null,
            true,
            null,
            $http.post,
            CALL.API.RECORD,
            { params: { idCall: currentCallId } },
            ['idCall'],
            true
          )
          .then((result) => {
            return { status: !!result };
          }),
      reject: () => $window.plivoWebSdk.client.reject(),
      resetCurrent: () => {
        currentCallId = '';
      },
      start: (params) =>
        dataService
          .apiRequest(
            null,
            null,
            true,
            null,
            $http.post,
            CALL.API.START,
            { params },
            ['source', 'destination'],
            true
          )
          .then((result) => {
            if (result?.status) {
              currentCallId = result.id;
              $window.plivoWebSdk.client.call(params.destination, {
                'X-PH-ACID': btoa($rootScope.CurrentAccount.id),
                'X-PH-ORID': btoa($rootScope.CurrentOrganization.id),
                'X-PH-GUID': btoa(getCurrent()),
                'X-PH-CLID': params.source
              });
            }
            return { status: result?.status === true };
          }),
      unmute: () => $window.plivoWebSdk.client.unmute()
    };
  })
  .service('callsService', ($http, $rootScope, CacheFactory, dataService, Call, CALL) => {
    let cache;
    if (!CacheFactory.get(CALL.CACHE.NAME)) {
      cache = CacheFactory(CALL.CACHE.NAME, CALL.CACHE.STORE);
    }
    const cacheKey = (params, requestName) =>
      JSON.stringify({
        idAccount: $rootScope.CurrentAccount.id,
        idOrganization: $rootScope.CurrentOrganization.id,
        type: requestName || CALL.CACHE.NAME,
        params
      });
    return {
      clearCache: () => cache.removeAll(),
      getAvailable: (params) =>
        dataService.apiRequest(
          cache,
          cacheKey(params),
          params?.ignoreCache === true,
          Call.build,
          $http.get,
          CALL.API.AVAILABLE,
          { params }
        )
    };
  })
  .constant('CALL', {
    API: {
      AVAILABLE: '/api/v1/calls/available/',
      ADD_TO_TICKET_AS_NOTE: '/api/v1/call/add-to-ticket-as-note/',
      ANSWER: '/api/v1/call/answer/',
      RECEIVE: '/api/v1/call/receive/',
      RECORD: '/api/v1/call/record/',
      START: '/api/v1/call/start/'
    },
    CACHE: {
      NAME: 'callCache',
      STORE: {
        maxAge: 60 * 1000,
        deleteOnExpire: 'aggressive',
        recycleFreq: 30 * 1000,
        storageMode: 'sessionStorage'
      }
    }
  });
